import React from "react";

const CropperWizard = ({
    show,
    onClose,
    stencilType,
    setStencilType,
    aspectRatio,
    setAspectRatio,
}) => {

    return (

        <div className="croppers-wizard-settings croppers-wizard__settings--visible croppers-wizard__settings">
            <button className="croppers-wizard-settings__close-button" onClick={onClose}>
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="-4 -4 24 24"
                xmlSpace="preserve"
                >
                <path
                    fill="#FFF"
                    d="M15.9 16.3c-.3 0-.5-.1-.7-.3L8.6 9.3 1.9 16c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l6.7-6.7L.5 1.2C.1.8.1.2.5-.2s1-.4 1.4 0l6.7 6.7 6.7-6.7c.4-.4 1-.4 1.4 0s.4 1 0 1.4L10 7.9l6.7 6.7c.4.4.4 1 0 1.4-.3.2-.5.3-.8.3z"
                />
                </svg>
            </button>
            <div className="croppers-wizard-settings__property">
                <div className="croppers-wizard-settings__property-title">Aspect Ratio</div>
                <div className="croppers-wizard-settings__property-values indiana-scroll-container indiana-scroll-container--hide-scrollbars">
                <div  className={`croppers-wizard-settings__icon ${
                                        aspectRatio === 'free'
                                            ? "croppers-wizard-settings__icon--active"
                                            : ""
                                    }`}
                    onClick={() => setAspectRatio("free")}>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={43}
                    height={33}
                    xmlSpace="preserve"
                    stroke="none"
                    >
                    <path d="M43 33H0V0h43v33zM1 32h41V1H1v31z" />
                    <path d="M11.7 20.2H9.6v-7.9h4.6V14h-2.6v1.5H14v1.7h-2.4v3zM17.7 17.4v2.9h-2.1v-7.9h2.6c2.1 0 3.2.8 3.2 2.3 0 .9-.4 1.6-1.3 2.1l2.3 3.4H20l-1.7-2.9h-.6zm0-1.6h.4c.7 0 1.1-.3 1.1-1 0-.5-.4-.8-1.1-.8h-.4v1.8zM27.7 20.2H23v-7.9h4.7V14h-2.5v1.2h2.4V17h-2.4v1.5h2.5v1.7zM33.7 20.2H29v-7.9h4.7V14h-2.5v1.2h2.4V17h-2.4v1.5h2.5v1.7z" />
                    </svg>
                </div>
                <div className={`croppers-wizard-settings__icon ${
                                        aspectRatio === '1:1'
                                            ? "croppers-wizard-settings__icon--active"
                                            : ""
                                    }`}
                    onClick={() => setAspectRatio('1:1')}>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={33}
                    height={33}
                    xmlSpace="preserve"
                    stroke="none"
                    >
                    <path d="M33 33H0V0h33v33zM1 32h31V1H1v31z" />
                    <path d="M13.5 20.2h-2.2v-5.6c-.1.2-.3.3-.5.5l-.8.8-1.1-1.4 2.7-2.2h1.9v7.9zM15.4 15.1c0-.3.1-.6.3-.8s.5-.3.8-.3c.4 0 .6.1.8.3s.3.4.3.8c0 .3-.1.6-.3.8s-.5.3-.8.3c-.4 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8zm0 4.2c0-.3.1-.6.3-.8.2-.2.5-.3.9-.3s.6.1.8.3.3.4.3.8c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3-.3-.2-.4-.4-.4-.8zM23.1 20.2H21v-5.6c-.1.2-.3.3-.5.5l-.9.7-1.1-1.4 2.7-2.2h1.9v8z" />
                    </svg>
                </div>
                <div className={`croppers-wizard-settings__icon ${
                                        aspectRatio === '1:2'
                                            ? "croppers-wizard-settings__icon--active"
                                            : ""
                                    }`}
                                    onClick={() => setAspectRatio('1:2')}>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={33}
                    height={66}
                    xmlSpace="preserve"
                    stroke="none"
                    >
                    <path d="M33 66H0V0h33v66zM1 65h31V1H1v64z" />
                    <path d="M13.5 36.7h-2.2v-5.6c-.1.2-.3.3-.5.5l-.8.8L8.9 31l2.7-2.2h1.9v7.9zM15.4 31.6c0-.3.1-.6.3-.8s.5-.3.8-.3c.4 0 .6.1.8.3s.3.4.3.8c0 .3-.1.6-.3.8s-.5.3-.8.3c-.4 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8zm0 4.2c0-.3.1-.6.3-.8.2-.2.5-.3.9-.3s.6.1.8.3.3.4.3.8c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3-.3-.2-.4-.4-.4-.8zM24.1 36.7h-5.7v-1.4l1.9-1.9c.5-.6.9-1 1.1-1.2.2-.2.3-.4.4-.5.1-.2.1-.3.1-.5s-.1-.4-.2-.5c-.1-.1-.3-.2-.6-.2-.2 0-.5.1-.8.2-.3.1-.5.3-.9.6L18.3 30c.4-.4.7-.6 1-.8.3-.2.6-.3.9-.4s.7-.1 1.1-.1c.5 0 1 .1 1.4.3.4.2.7.4.9.8.2.3.3.7.3 1.1 0 .3 0 .6-.1.9s-.2.5-.4.8c-.2.3-.4.5-.6.8s-.8.8-1.7 1.6h3v1.7z" />
                    </svg>
                </div>
                <div className={`croppers-wizard-settings__icon ${
                                        aspectRatio === '3:4'
                                            ? "croppers-wizard-settings__icon--active"
                                            : ""
                                    }`}
                                    onClick={() => setAspectRatio('3:4')}>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={33}
                    height={43}
                    xmlSpace="preserve"
                    stroke="none"
                    >
                    <path d="M33 43H0V0h33v43zM1 42h31V1H1v41z" />
                    <path d="M14.2 19.1c0 .5-.1.9-.4 1.3-.3.3-.7.6-1.3.8 1.3.2 2 .8 2 1.9 0 .7-.3 1.3-.9 1.7-.6.4-1.4.6-2.4.6-.4 0-.8 0-1.2-.1-.4-.1-.7-.2-1.2-.3v-1.8c.3.2.7.3 1 .4.4.1.7.1 1 .1.5 0 .8-.1 1-.2.2-.1.3-.3.3-.6 0-.2-.1-.4-.2-.5s-.3-.2-.5-.3c-.2-.1-.6-.1-1-.1h-.5v-1.6h.5c1.1 0 1.6-.3 1.6-.8 0-.2-.1-.4-.2-.5 0-.1-.2-.1-.5-.1-.5 0-1 .2-1.6.5L8.9 18c.4-.3.8-.5 1.3-.6.4-.1.9-.2 1.5-.2.8 0 1.5.2 1.9.5s.6.8.6 1.4zM15.4 20.1c0-.3.1-.6.3-.8s.5-.3.8-.3c.4 0 .6.1.8.3s.3.4.3.8c0 .3-.1.6-.3.8s-.5.3-.8.3c-.4 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8zm0 4.2c0-.3.1-.6.3-.8.2-.2.5-.3.9-.3s.6.1.8.3.3.4.3.8c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3-.3-.2-.4-.4-.4-.8zM24.4 23.7h-.9v1.5h-2.1v-1.5h-3.1v-1.6l3.3-4.8h2V22h.9v1.7zm-3-1.6V20h-.1c-.1.3-.3.5-.4.8l-.9 1.3h1.4z" />
                    </svg>
                </div>
                <div className={`croppers-wizard-settings__icon ${
                                        aspectRatio === '2:1'
                                            ? "croppers-wizard-settings__icon--active"
                                            : ""
                                    }`}
                                    onClick={() => setAspectRatio('2:1')}>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={65}
                    height={31}
                    xmlSpace="preserve"
                    stroke="none"
                    >
                    <path d="M65 31H0V0h65v31zM1 30h63V1H1v29z" />
                    <path d="M30.5 19.2h-5.7v-1.4l1.9-1.9c.5-.6.9-1 1.1-1.2.2-.2.3-.4.4-.5.1-.2.1-.3.1-.5s-.1-.4-.2-.5-.4-.2-.6-.2c-.2 0-.5.1-.7.2-.3.1-.5.3-.9.6l-1.2-1.4c.4-.4.7-.6 1-.8.3-.2.6-.3.9-.4.3-.1.7-.1 1.1-.1.5 0 1 .1 1.4.3.4.2.7.4.9.8.2.3.3.7.3 1.1 0 .3 0 .6-.1.9-.1.3-.2.5-.4.8-.2.3-.4.5-.6.8-.3.3-.8.8-1.7 1.6v.1h3v1.7zM31.4 14.1c0-.3.1-.6.3-.8s.5-.3.8-.3c.4 0 .6.1.8.3s.3.4.3.8c0 .3-.1.6-.3.8s-.5.3-.8.3c-.4 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8zm0 4.2c0-.3.1-.6.3-.8.2-.2.5-.3.9-.3s.6.1.8.3.3.4.3.8c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3-.3-.2-.4-.4-.4-.8zM39.1 19.2H37v-5.6c-.1.2-.3.3-.5.5l-.9.7-1.1-1.4 2.7-2.2h1.9v8z" />
                    </svg>
                </div>
                {/* <div className={`croppers-wizard-settings__icon ${
                                        aspectRatio === '1:2 x 2:1'
                                            ? "croppers-wizard-settings__icon--active"
                                            : ""
                                    }`}
                                    onClick={() => setAspectRatio('1:2 x 2:1')}>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={65}
                    height={65}
                    xmlSpace="preserve"
                    stroke="none"
                    >
                    <path d="M65 65H0V34h65v31zM1 64h63V35H1v29z" />
                    <path d="M30.5 53.2h-5.7v-1.4l1.9-1.9c.5-.6.9-1 1.1-1.2.2-.2.3-.4.4-.5.1-.2.1-.3.1-.5s-.1-.4-.2-.5-.4-.2-.6-.2c-.2 0-.5.1-.7.2-.3.1-.5.3-.9.6l-1.2-1.4c.4-.4.7-.6 1-.8.3-.2.6-.3.9-.4.3-.1.7-.1 1.1-.1.5 0 1 .1 1.4.3.4.2.7.4.9.8.2.3.3.7.3 1.1 0 .3 0 .6-.1.9-.1.3-.2.5-.4.8-.2.3-.4.5-.6.8-.3.3-.8.8-1.7 1.6v.1h3v1.7zM31.4 48.1c0-.3.1-.6.3-.8s.5-.3.8-.3c.4 0 .6.1.8.3s.3.4.3.8c0 .3-.1.6-.3.8s-.5.3-.8.3c-.4 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8zm0 4.2c0-.3.1-.6.3-.8.2-.2.5-.3.9-.3s.6.1.8.3.3.4.3.8c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3-.3-.2-.4-.4-.4-.8zM39.1 53.2H37v-5.6c-.1.2-.3.3-.5.5l-.9.7-1.1-1.4 2.7-2.2h1.9v8z" />
                    <g>
                        <path d="M29.5 21.3h-2.2v-5.6c-.1.2-.3.3-.5.5l-.8.8-1.1-1.4 2.7-2.2h1.9v7.9zM31.4 16.2c0-.3.1-.6.3-.8s.5-.3.8-.3c.4 0 .6.1.8.3s.3.4.3.8c0 .3-.1.6-.3.8s-.5.3-.8.3c-.4 0-.6-.1-.8-.3-.2-.3-.3-.5-.3-.8zm0 4.2c0-.3.1-.6.3-.8.2-.2.5-.3.9-.3s.6.1.8.3.3.4.3.8c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.4 0-.6-.1-.8-.3-.3-.2-.4-.5-.4-.8zM40.1 21.3h-5.7v-1.4l1.9-1.9c.5-.6.9-1 1.1-1.2.2-.2.3-.4.4-.5.1-.2.1-.3.1-.5s-.1-.4-.2-.5c-.1-.1-.3-.2-.6-.2-.2 0-.5.1-.8.2-.3.1-.5.3-.9.6l-1.2-1.4c.4-.4.7-.6 1-.8.3-.2.6-.3.9-.4s.7-.1 1.1-.1c.5 0 1 .1 1.4.3.4.2.7.4.9.8.2.3.3.7.3 1.1 0 .3 0 .6-.1.9s-.2.5-.4.8c-.2.3-.4.5-.6.8s-.8.8-1.7 1.6v.1h3v1.7z" />
                    </g>
                    <g>
                        <path d="M48 65h-1.5v-1h.5v-1.5h1V65zm-4.5 0h-3v-1h3v1zm-6 0h-3v-1h3v1zm-6 0h-3v-1h3v1zm-6 0h-3v-1h3v1zm-6 0H17v-3.5h1V64h1.5v1zM48 59.5h-1v-3h1v3zm-30-1h-1v-3h1v3zm30-5h-1v-3h1v3zm-30-1h-1v-3h1v3zm30-5h-1v-3h1v3zm-30-1h-1v-3h1v3zm30-5h-1v-3h1v3zm-30-1h-1v-3h1v3zm30-5h-1v-3h1v3zm-30-1h-1v-3h1v3zm30-5h-1v-3h1v3zm-30-1h-1v-3h1v3zm30-5h-1v-3h1v3zm-30-1h-1v-3h1v3zm30-5h-1v-3h1v3zm-30-1h-1v-3h1v3zm30-5h-1v-3h1v3zm-30-1h-1v-3h1v3zm30-5h-1v-3h1v3zm-30-1h-1v-3h1v3zM46.5 1h-3V0h3v1zm-6 0h-3V0h3v1zm-6 0h-3V0h3v1zm-6 0h-3V0h3v1zm-6 0h-3V0h3v1z" />
                    </g>
                    </svg>
                </div> */}
                </div>
            </div>
            <div className="croppers-wizard-settings__property">
                <div className="croppers-wizard-settings__property-title">Stencil Type</div>
                <div className="croppers-wizard-settings__property-values indiana-scroll-container indiana-scroll-container--hide-scrollbars">
                <div className={`croppers-wizard-settings__icon ${
                                    stencilType === "rectangle"
                                        ? "croppers-wizard-settings__icon--active"
                                        : ""
                                }`}
                                onClick={() => setStencilType("rectangle")}>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="58.6"
                    height="51.5"
                    xmlSpace="preserve"
                    >
                    <path
                        stroke="none"
                        d="M6.3 46v2.6H4.4v-7.1h2.3c1.9 0 2.9.7 2.9 2.1 0 .8-.4 1.5-1.2 1.9l2.1 3.1H8.3L6.8 46h-.5zm0-1.4h.4c.7 0 1-.3 1-.9 0-.5-.3-.7-1-.7h-.4v1.6zM13.7 48.7c-.9 0-1.6-.2-2.1-.7-.5-.5-.8-1.2-.8-2.1 0-.9.2-1.7.7-2.2.5-.5 1.1-.7 2-.7.8 0 1.5.2 1.9.7.5.4.7 1.1.7 1.9v.8h-3.4c0 .3.1.6.3.7s.5.3.9.3c.3 0 .6 0 .9-.1l.9-.3v1.4c-.3.2-.6.3-.9.3h-1.1zm-.1-4.4c-.2 0-.4.1-.6.2-.2.1-.2.4-.3.7h1.6c0-.3-.1-.5-.2-.6s-.3-.3-.5-.3zM19.7 48.7c-.9 0-1.6-.2-2.1-.7s-.6-1.2-.6-2.1c0-.9.3-1.6.8-2.1s1.2-.8 2.1-.8c.6 0 1.2.1 1.8.4l-.6 1.4c-.2-.1-.4-.2-.6-.2-.2-.1-.4-.1-.6-.1-.3 0-.5.1-.7.4s-.3.6-.3 1c0 .9.3 1.3 1 1.3.6 0 1.1-.2 1.6-.5v1.5c-.5.3-1.1.5-1.8.5zM25.3 47.2c.3 0 .6-.1.9-.2v1.4c-.3.1-.5.2-.7.2-.2 0-.5.1-.8.1-.6 0-1.1-.2-1.4-.5-.3-.3-.4-.8-.4-1.4v-2.3h-.7v-.8l.8-.6.5-1.2h1.3V43h1.4v1.4h-1.4v2.2c0 .4.2.6.5.6zM30.8 48.6l-.4-.7c-.3.3-.5.5-.8.7s-.6.2-1 .2c-.5 0-.9-.2-1.2-.5s-.4-.8-.4-1.3c0-.6.2-1 .6-1.3.4-.3 1-.4 1.8-.5h.9V45c0-.5-.2-.7-.7-.7-.4 0-.9.1-1.5.4l-.6-1.3c.6-.3 1.5-.5 2.4-.5.7 0 1.3.2 1.6.5.4.4.6.8.6 1.5v3.6h-1.3zm-1.4-1.2c.2 0 .4-.1.6-.2s.2-.3.2-.6v-.4h-.4c-.6 0-.9.3-.9.7 0 .3.1.5.5.5zM36.9 48.6v-3c0-.4-.1-.6-.2-.8-.1-.2-.3-.3-.5-.3-.3 0-.6.1-.7.4-.1.3-.2.7-.2 1.3v2.4h-1.9v-5.5h1.4l.2.7h.1c.2-.3.4-.5.7-.6s.6-.2 1-.2c.6 0 1.1.2 1.4.5.3.4.5.9.5 1.5v3.6h-1.8zM45.4 43.1v.9l-.8.3c.1.2.2.4.2.7 0 .6-.2 1.1-.6 1.4-.4.3-1 .5-1.9.5h-.5c0 .1-.1.2-.1.2 0 .1.1.2.2.2.2.1.4.1.6.1h.9c1.2 0 1.9.5 1.9 1.6 0 .7-.3 1.2-.9 1.6-.5.2-1.3.4-2.4.4-.8 0-1.4-.1-1.8-.4-.4-.3-.6-.6-.6-1.1 0-.7.4-1.1 1.2-1.3-.2-.1-.3-.2-.4-.3-.1-.2-.2-.3-.2-.5s0-.3.1-.5c.1-.1.3-.3.6-.5-.3-.1-.5-.3-.7-.6-.2-.3-.2-.6-.2-1 0-.6.2-1.1.6-1.4s1-.5 1.8-.5h.5c.2 0 .4 0 .5.1h2zm-4.2 6.2c0 .2.1.3.3.4.2.1.4.1.7.1.5 0 .8-.1 1.1-.2.3-.1.4-.3.4-.4 0-.1-.1-.3-.3-.3-.2-.1-.4-.1-.7-.1H42c-.2 0-.4 0-.5.1-.2.1-.3.3-.3.4zm.6-4.4c0 .6.2.8.6.8.2 0 .3-.1.4-.2.1-.1.1-.3.1-.6 0-.6-.2-.9-.6-.9-.3 0-.5.3-.5.9zM48.1 48.6h-1.9V41h1.9v7.6zM52.1 48.7c-.9 0-1.6-.2-2.1-.7-.5-.5-.8-1.2-.8-2.1 0-.9.2-1.7.7-2.2.5-.5 1.1-.7 2-.7.8 0 1.5.2 1.9.7.5.4.7 1.1.7 1.9v.8h-3.4c0 .3.1.6.3.7s.5.3.9.3c.3 0 .6 0 .9-.1l.9-.3v1.4c-.3.2-.6.3-.9.3h-1.1zm-.1-4.4c-.2 0-.4.1-.6.2-.2.1-.2.4-.3.7h1.6c0-.3-.1-.5-.2-.6s-.3-.3-.5-.3z"
                    />
                    <path
                        fill="none"
                        strokeMiterlimit={10}
                        d="M55.8 32.5h-53c-1.3 0-2.3-1-2.3-2.3V2.8C.5 1.5 1.5.5 2.8.5h52.9c1.3 0 2.3 1 2.3 2.3v27.4c.1 1.3-1 2.3-2.2 2.3z"
                    />
                    </svg>
                </div>
                {/* <div className={`croppers-wizard-settings__icon ${
                                    stencilType === "circle"
                                        ? "croppers-wizard-settings__icon--active"
                                        : ""
                                }`}
                                onClick={() => setStencilType("circle")}>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={33}
                    height="51.5"
                    xmlSpace="preserve"
                    >
                    <path
                        stroke="none"
                        d="M5.8 43c-.5 0-.8.2-1.1.6-.3.4-.4.9-.4 1.6 0 1.4.5 2.1 1.6 2.1.3 0 .6 0 .9-.1l.9-.3v1.6c-.6.3-1.3.4-2 .4-1.1 0-1.9-.3-2.5-.9s-.9-1.5-.9-2.7c0-.7.1-1.4.4-1.9s.7-1 1.2-1.3c.5-.3 1.1-.5 1.8-.5.8 0 1.5.2 2.2.5l-.6 1.5c-.3-.1-.5-.2-.8-.3s-.4-.3-.7-.3zM9 41.7c0-.3.1-.5.2-.6s.4-.2.8-.2.6.1.8.2.2.4.2.6c0 .6-.3.8-1 .8s-1-.2-1-.8zm1.9 6.9H9v-5.5h1.9v5.5zM15.6 43h.6l-.2 1.8c-.2 0-.4-.1-.6-.1-.4 0-.7.1-.9.3-.2.2-.3.5-.3.8v2.7h-1.9V43h1.4l.3 1h.1c.2-.3.4-.5.7-.7.2-.2.5-.3.8-.3zM19.5 48.7c-.9 0-1.6-.2-2.1-.7-.5-.5-.7-1.2-.7-2.1 0-.9.3-1.6.8-2.1s1.2-.8 2.2-.8c.6 0 1.2.1 1.8.4l-.6 1.4c-.2-.1-.4-.2-.6-.2-.2-.1-.4-.1-.6-.1-.3 0-.5.1-.7.4-.2.2-.3.6-.3 1 0 .9.3 1.3 1 1.3.6 0 1.1-.2 1.6-.5v1.5c-.5.3-1.1.5-1.8.5zM24.3 48.6h-1.9V41h1.9v7.6zM28.3 48.7c-.9 0-1.6-.2-2.1-.7-.5-.5-.8-1.2-.8-2.1 0-.9.2-1.7.7-2.2.5-.5 1.1-.7 2-.7.8 0 1.5.2 1.9.7.5.4.7 1.1.7 1.9v.8h-3.4c0 .3.1.6.3.7.2.2.5.3.9.3.3 0 .6 0 .9-.1l.9-.3v1.4c-.3.2-.6.3-.9.3h-1.1zm-.1-4.4c-.2 0-.4.1-.6.2-.2.1-.2.4-.3.7H29c0-.3-.1-.5-.2-.6-.2-.2-.4-.3-.6-.3z"
                    />
                    <circle
                        fill="none"
                        strokeMiterlimit={10}
                        cx="16.5"
                        cy="16.5"
                        r={16}
                    />
                    </svg>
                </div> */}
                </div>
            </div>
            <div className="croppers-wizard-settings__inputs indiana-scroll-container indiana-scroll-container--hide-scrollbars">
                <div className="croppers-wizard-settings__input">
                <div className="settings-input">
                    <div className="settings-input__label">Min Width</div>
                    <input
                    className="settings-input__input"
                    placeholder={0}
                    type="number"
                    defaultValue=""
                    />
                </div>
                </div>
                <div className="croppers-wizard-settings__input">
                <div className="settings-input">
                    <div className="settings-input__label">Min Height</div>
                    <input
                    className="settings-input__input"
                    placeholder={0}
                    type="number"
                    defaultValue=""
                    />
                </div>
                </div>
                <div className="croppers-wizard-settings__input">
                <div className="settings-input">
                    <div className="settings-input__label">Max Width</div>
                    <input
                    className="settings-input__input"
                    placeholder="∞"
                    type="number"
                    defaultValue=""
                    />
                </div>
                </div>
                <div className="croppers-wizard-settings__input">
                <div className="settings-input">
                    <div className="settings-input__label">Max Height</div>
                    <input
                    className="settings-input__input"
                    placeholder="∞"
                    type="number"
                    defaultValue=""
                    />
                </div>
                </div>
            </div>
        </div>

        
    );
};

export default CropperWizard;